import { Check } from "@gravity-ui/icons";
import { Flex, Label, Link, Text } from "@gravity-ui/uikit";
import { CertInfoResponse } from "definitions/poizon-api";
import { useCallback, useMemo } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice.ts";
import { getLinkForPoizonApp } from "src/util/poizonOpenApp.ts";

import css from "./CertInfo.module.scss";

interface CertInfoProps {
  certInfo: CertInfoResponse | null;
  isLoading: boolean;
}

export const CertInfo = ({ certInfo, isLoading }: CertInfoProps) => {
  const { isMobile } = useGravityDevice();

  const appHref = useMemo(() => {
    if (!certInfo) return "";
    return getLinkForPoizonApp(
      { skuId: 0, spuId: certInfo.orderInfo.item.productId },
      isMobile,
    );
  }, [certInfo, isMobile]);

  const prettyCertNo = useCallback((text: string) => {
    return [text.slice(0, 3), text.slice(3, 6), text.slice(6)].join(" ");
  }, []);

  if (isLoading || !certInfo) return <>Loading</>;

  return (
    <Flex
      direction={isMobile ? "column" : "row"}
      className={isMobile ? css.contentMargin : css.contentMarginDesktop}
      gap="10"
      justifyContent={"center"}
    >
      <div className={css.productLogo}>
        <img
          src={certInfo.orderInfo.item.productLogo}
          alt={certInfo.orderInfo.item.productTitle}
        />
      </div>
      <Flex direction="column" gap="5" className={css.content}>
        <Text variant="subheader-3">
          {certInfo.orderInfo.item.productTitle}
        </Text>
        <Flex gap="1" wrap="wrap">
          <Label
            type={"copy"}
            interactive={true}
            value={certInfo.orderInfo.orderNo}
            copyText={certInfo.orderInfo.orderNo}
          >
            Номер заказа
          </Label>
          <Label
            type={"copy"}
            interactive={true}
            value={certInfo.orderInfo.item.product.articleNumber}
            copyText={certInfo.orderInfo.item.product.articleNumber}
          >
            Артикул
          </Label>
          <Label
            type={"copy"}
            interactive={true}
            value={certInfo.orderInfo.item.productId.toString()}
            copyText={certInfo.orderInfo.item.productId.toString()}
          >
            ID товара
          </Label>
          <Label value={certInfo.orderInfo.formatPayTime}>Оплачено</Label>
          <Label value={certInfo.orderInfo.item.specification}>Вариант</Label>
        </Flex>
        {appHref && (
          <Link target="_blank" href={appHref}>
            Открыть на Poizon
          </Link>
        )}
        <Flex gap="2" direction={"column"}>
          <Flex alignItems={"center"} gap="2">
            <Check color={"#13d613"} width={22} height={22} />
            <Text variant="header-1">{prettyCertNo(certInfo.certNo)}</Text>
          </Flex>
          {certInfo.clasp.map((clasp, index) => (
            <Flex alignItems={"center"} gap="2" key={index}>
              <Check color={"#13d613"} width={22} height={22} />
              <Text variant="header-1">{prettyCertNo(clasp.claspCode)}</Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
